// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ebwi","col":"styles_col__1SGu4"};